export default "__VITE_ASSET__8ZTB8AYJ__"